import { api } from '@/api'

export interface UploadServiceLogoResponse {
  data: {
    logo_url: string
  }
}

export function uploadServiceLogoAction(serviceSlug: string, logo: File): Promise<UploadServiceLogoResponse> {
  const formData = new FormData()
  formData.append('logo', logo)

  return api.v2.post(`/services/${serviceSlug}/logo`, formData)
}
